import React, { useMemo } from "react";
import { Box, Grid, Card, IconButton } from "@mui/material";
// import { DemoContainer } from "@mui/x-date-pickers/containers";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// removed unused date pickers
import AppLoading from "verticales/AppLoading.tsx";
import fetchData from "verticales/FetchData";
import TableMaestros from "verticales/TableMaestros.tsx";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import Footer from "examples/Footer";
import MDButton from "components/MDButton";
import AccessIcon from "@mui/icons-material/Https";
import Tooltip from "@mui/material/Tooltip";
import UtilModal from "verticales/UtilModal.js";
import Recursos from "./recursos.js";

// removed csv export config and related unused imports

// removed unused theme overrides

const url = "https://5djo5qwa3l.execute-api.us-east-1.amazonaws.com/dimo-goyito/ec2/";
const context = "accesos-pos1";

const Example = (props) => {
  const [data, setData] = React.useState([]);
  const [dataAccess, setDataAccess] = React.useState([]);
  const [blocking, setBlocking] = React.useState(false);
  const [msgAction, setMsgAction] = React.useState(context);

  // removed unused handleExportData

  const handleButtonClick = async () => {
    // const dateIni = fechaIni ? fechaIni.toDate().getTime() : null;
    // const dateFin = fechaFin ? fechaFin.toDate().getTime() : null;

    const params = {
      action: "get",
    };

    setBlocking(true);
    setMsgAction("Accesos Pos1");

    try {
      const resp = await fetchData(url, context, params);
      console.log(resp);
      setData(resp.users);
      setDataAccess(resp.access);
    } catch (error) {
      console.error("Error fetching data: ", error);
      setData([]);
      setDataAccess([]);
    } finally {
      setBlocking(false);
    }
  };

  const [rowSelect, setRowSelect] = React.useState({});
  const [openModal, setOpenModal] = React.useState(false);
  const handleOpenModal = (row) => {
    setRowSelect(row);
    setOpenModal(true);
  };

  // const handleCloseModal = async (refresh) => {
  //   setOpenModal(false);
  // };
  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const renderView = () => {
    return <Recursos access={dataAccess} row={rowSelect} handleCloseModal={handleCloseModal} />;
  };

  /** datos table maestros11 */
  const columns = useMemo(
    () => [
      { header: "correosiesa", accessorKey: "correosiesa" },
      { header: "email", accessorKey: "email" },
      { header: "agente", accessorKey: "agente" },
      { header: "idtoken", accessorKey: "idtoken" },
    ],
    []
  );

  let renderOpcRowsSid = (row) => {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", width: "100%", padding: "0" }}>
        <Tooltip title="Accesos">
          <IconButton onClick={() => handleOpenModal(row)}>
            <AccessIcon />
          </IconButton>
        </Tooltip>
      </Box>
    );
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={1}>
        <Grid container spacing={1}>
          <Grid item xs={12} md={12} lg={12}>
            <Card>
              <Grid item xs={12} md={6} lg={12}>
                <MDBox m={1}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <Box
                      sx={{
                        display: "grid",
                        gridTemplateColumns: {
                          xs: "1fr",
                          sm: "repeat(2, 1fr)",
                          md: "repeat(3, 1fr)",
                        },
                        gap: 1,
                        alignItems: "center",
                        justifyItems: "start",
                      }}
                    >
                      <MDButton variant="contained" disableElevation onClick={handleButtonClick}>
                        Buscar
                      </MDButton>
                    </Box>
                  </LocalizationProvider>
                </MDBox>
              </Grid>
              <Grid item xs={12} md={12} lg={12}>
                <MDBox m={1}>
                  {blocking ? (
                    <AppLoading {...props} titleCustom={msgAction} />
                  ) : (
                    <TableMaestros
                      arrayColumns={columns}
                      data={data}
                      height={320}
                      handleOpenModal={handleOpenModal}
                      renderOpcRows={renderOpcRowsSid}
                    />
                  )}
                </MDBox>
              </Grid>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
      <UtilModal
        openModal={openModal}
        handleCloseModal={handleCloseModal}
        renderView={renderView}
      />
    </DashboardLayout>
  );
};

export default Example;
